import { render, staticRenderFns } from "./AgencyCodePrefixPickerModal.vue?vue&type=template&id=52063d67"
import script from "./AgencyCodePrefixPickerModal.vue?vue&type=script&lang=ts"
export * from "./AgencyCodePrefixPickerModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports